<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.heading" [ttModel]="setting.heading"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-button-goto ttText="projectprosess_new" ttGoto="projectprocess" [ttGotoParms]="{ project_keyno: setting.project_keyno, projectprosess_keyno: '0', projectprosess_keyno_belongto: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list class="col-xs-12 col-md-4 sp-0" [ttData]="itemsListPosts"></tt-list>
</tt-page>
